import { ProgressBar } from '@flos/react-ui';
import { onsaProgressAtom } from '../../recoil/atoms/onsaProgressAtom';
import { useRecoilValue } from 'recoil';

const OnsaProgressBar = (): React.JSX.Element => {
    const { title, currentStep, totalSteps } = useRecoilValue(onsaProgressAtom);
    return (
        <>
            <span className="u-display-flex u-flex-justify-center u-color-supplement-grey-medium">
                {title}
            </span>
            <ProgressBar currentStep={currentStep} totalSteps={totalSteps} title={title} />
        </>
    );
};

export default OnsaProgressBar;
